"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.REGISTER = exports.INVITE_EMAIL_VERIFY = exports.VALIDATE_EMAIL_CODE = exports.VALIDATE_SMS_CODE = exports.SEND_EMAIL_CODE = exports.SEND_SMS_CODE = exports.SIGN_UP = exports.SIGN_IN = exports.SIGN_OUT = exports.SIGN_IN_OR_SIGN_UP = void 0;
// login signin, register
exports.SIGN_IN_OR_SIGN_UP = '/signIn';
// logout, sign out
exports.SIGN_OUT = '/signOut';
/**
 * login, sign in, deprecated
 *
 * @deprecate
 */
exports.SIGN_IN = '/auth/signIn';
/**
  * register, sign up, deprecated
  *
  * @deprecate
  */
exports.SIGN_UP = '/auth/signUp';
// ================ Authorization======================
// ================ Public stuffs ======================
/**
 * Send SMS verify code
 */
exports.SEND_SMS_CODE = '/base/action/sms/code';
/**
  * Send email verify code
  */
exports.SEND_EMAIL_CODE = '/base/action/mail/code';
/**
  * Validate SMS verify code
  */
exports.VALIDATE_SMS_CODE = '/base/action/sms/code/validate';
/**
  *
  * Validate email verify code.
  *
  * When to use:
  *   change email or space main admin when no phone number.
  *
  */
exports.VALIDATE_EMAIL_CODE = '/base/action/email/code/validate';
/**
  * Space - invite verify code validate
  */
exports.INVITE_EMAIL_VERIFY = '/base/action/invite/valid';
exports.REGISTER = '/register';
//# sourceMappingURL=url.auth.js.map